// empty file prevent babel-plugin-import error
import '../../../../lib/style/index.less';
